import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import { faqs } from "../data/faqs";
import { useLang } from "../context/LanguageContext";

export default function FAQ({ items = faqs, eyebrow, title, subtitle, light = false }) {
  const [open, setOpen] = useState(0);
  const { lang } = useLang();
  const isEs = lang === "es";
  const eb = eyebrow ?? (isEs ? "Preguntas" : "Questions");
  const tt = title   ?? (isEs ? "Preguntas frecuentes" : "Frequently asked");
  const sb = subtitle ?? (isEs
    ? "Todo lo que quisieras saber antes de visitarnos en Los Gatos, CA."
    : "Everything you might want to know before you visit Nina's Taqueria in Los Gatos, CA.");
  return (
    <section className={`py-24 md:py-28 ${light ? "bg-cream" : "bg-cream-50"}`}>
      <div className="max-w-4xl mx-auto px-6">
        <Reveal>
          <SectionHeading eyebrow={eb} title={tt} subtitle={sb} />
        </Reveal>
        <div className="mt-4 divide-y divide-cream-100 border-y border-cream-100">
          {items.map((f, i) => {
            const isOpen = open === i;
            const q = isEs ? (f.qEs || f.q) : f.q;
            const a = isEs ? (f.aEs || f.a) : f.a;
            return (
              <Reveal key={f.q} delay={((i % 3) + 1)}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-item-${i}`}
                  className="w-full flex items-center justify-between text-left py-5 md:py-6 gap-4 group"
                >
                  <span className="font-display text-lg md:text-xl font-medium text-granite-dark group-hover:text-brand transition-colors">
                    {q}
                  </span>
                  <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 border transition-colors ${isOpen ? "bg-brand text-cream border-brand" : "border-cream-100 text-granite group-hover:border-brand/50 group-hover:text-brand"}`}>
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-500 ease-out ${isOpen ? "max-h-96 opacity-100 pb-6" : "max-h-0 opacity-0"}`}>
                  <p className="text-granite/75 text-[15px] leading-relaxed max-w-3xl">
                    {a}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
